export default __webpack_public_path__ + "0312903a0da24f55ef73767cb08a309d.ttf";